import { createTheme } from "@mui/material/styles";
import colors from "./colors";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.button.primaryBg,
      dark: colors.button.primaryHover,
      contrastText: colors.button.primaryText,
    },
    secondary: {
      main: colors.button.secondaryText,
      light: colors.button.secondaryBg,
      contrastText: colors.button.secondaryText,
    },
    background: {
      default: colors.background.main,
      paper: colors.background.section,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.muted,
    },
    divider: colors.divider,
    navbar: {
      bg: colors.navbar.bg,
      border: colors.navbar.border,
      text: colors.navbar.text,
      hover: colors.navbar.hover,
    },
    card: {
      bg: colors.card.bg,
      border: colors.card.border,
      hover: colors.card.hover,
      shadow: colors.card.shadow,
    },
    footer: {
      bg: colors.footer.bg,
      text: colors.footer.text,
      links: colors.footer.links,
      linksHover: colors.footer.linksHover,
    },
    success: { main: colors.status.success },
    warning: { main: colors.status.warning },
    error: { main: colors.status.error },
    info: { main: colors.status.info },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background.main,
          color: colors.text.primary,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.navbar.bg,
          color: colors.navbar.text,
          borderBottom: `1px solid ${colors.navbar.border}`,
          boxShadow: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.card.bg,
          border: `1px solid ${colors.card.border}`,
          boxShadow: `0 8px 24px ${colors.card.shadow}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.section,
        },
        outlined: {
          borderColor: colors.divider,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: colors.divider,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
        containedPrimary: {
          backgroundColor: colors.button.primaryBg,
          color: colors.button.primaryText,
          "&:hover": {
            backgroundColor: colors.button.primaryHover,
          },
        },
        outlined: {
          backgroundColor: colors.button.secondaryBg,
          color: colors.button.secondaryText,
          borderColor: "transparent",
          "&:hover": {
            backgroundColor: colors.button.secondaryHover,
            borderColor: "transparent",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.input.bg,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.input.border,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.input.focus,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.input.focus,
            borderWidth: 1,
          },
          "& input::placeholder": {
            color: colors.input.placeholder,
            opacity: 1,
          },
        },
      },
    },
  },
});

export default theme;
